import React from "react";
import * as Icons from "lucide-react";
import { SERVICES } from "../data/mock";
import { useReveal } from "./useReveal";

const hexToRgba = (hex, a) => {
  const h = hex.replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

const Services = () => {
  const ref = useReveal();
  return (
    <section id="services" className="py-24 bg-[#fbfafc]">
      <div className="aaa-container">
        <div className="text-center max-w-2xl mx-auto">
          <p className="aaa-eyebrow mb-3">Our Products &amp; Services</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold">
            Awesome Products &amp; Services
          </h2>
        </div>

        <div ref={ref} className="aaa-fade-up mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => {
            const Icon = Icons[s.icon] || Icons.Cpu;
            return (
              <div
                key={s.id}
                className="aaa-service-card bg-white rounded-xl p-8 border-t-4"
                style={{ borderTopColor: s.color, boxShadow: "0 10px 30px -18px rgba(61,59,84,0.18)" }}
              >
                <div
                  className="w-16 h-16 rounded-xl flex items-center justify-center mb-6"
                  style={{ backgroundColor: hexToRgba(s.color, 0.12) }}
                >
                  <Icon size={30} style={{ color: s.color }} strokeWidth={1.6} />
                </div>
                <h3 className="font-display text-xl font-bold mb-2">{s.title}</h3>
                <p className="text-[#6f6d84] leading-relaxed text-[0.95rem]">{s.desc}</p>
              </div>
            );
          })}

          {/* CTA card filling the 6th slot */}
          <div
            className="rounded-xl p-8 flex flex-col justify-center aaa-hero-gradient text-white"
          >
            <h3 className="font-display text-xl font-bold mb-2 text-white">
              Not sure what you need?
            </h3>
            <p className="text-white/85 text-[0.95rem] leading-relaxed mb-5">
              Tell us about your workload and we'll configure the right hardware for you.
            </p>
            <button
              onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
              className="self-start bg-white text-[#7a4fa3] px-6 py-2.5 rounded-md font-medium hover:-translate-y-0.5 transition-transform duration-300"
            >
              Talk to us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
